export const step3 = {
  radioPlans: {
    value: '',
    isValid: false,
  },
  checkLoan: {
    value: false,
    isValid: false,
  },
  checkMortgage: {
    value: false,
    isValid: false,
  },
  checkOther: {
    value: false,
    isValid: false,
  },
  checkAccept: {
    value: false,
    isValid: false,
  },
  financialEntity:{
    value:'',
    isValid:false
  },
  allProductToggle:{
    value:true,
    isValid: true
  },
  bankAccountsToggle:{
    value:true,
    isValid: true
  },
  creditCardToggle:{
    value:true,
    isValid: true
  },
  creditLineToggle:{
    value:true,
    isValid: true
  },
  revolvingCreditToggle:{
    value:true,
    isValid:true
  },
  loanToggle:{
    value:true,
    isValid: true
  },
  otherProductsToggle:{
    value:false,
    isValid: false
  },
  portabilityRequestInfo:{
    value:true,
    isValid: true
  },
  termsConditions: {
    value: false,
    isValid: false,
    error: null
  },
  coOwnerName:{
    value: '',
    isValid: false,
  },
  coOwnerCustomerId:{
    value: '',
    isValid: false,
  },
  coOwnerCheck:{
    value: false,
    isValid: false,
  },
  voucher:{
    value: null,
    isValid:false
  }
};